import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { playerBetsRouteI18n } from '@bcf-v2/routes/sportsbook/app/i18n/player-bets-route-i18n';

export function playerBetsRoutePath(): string {
  return `/${langRouteI18n()}/${playerBetsRouteI18n()}`;
}
